import { h, render, Component } from 'preact';

export class EmailField extends Component {
	render(props, state) {
		const {
			email
		} = props;

		if(!email) {
			return null;
		}
		return (
			<div>
        <span class="uk-icon-envelope"></span>&nbsp;
        <span><a href={"mailto:" + email}>{email}</a></span>
      </div>
		)
	}
}